module.exports = __webpack_public_path__ + "img/180.d28365c0.jpg";